import { Step } from "react-joyride";

/**
 * Guided tour for the Pre-Compliance step (Stage 1 — confirm questions).
 *
 * Each step targets a `data-testid` rendered in Stage1ConfirmQuestions. Joyride
 * auto-skips any target that isn't currently present (e.g. the questions list is
 * absent when the set is empty), so the same tour works for the empty and the
 * seeded-from-defaults states.
 */
export const preComplianceSteps: Step[] = [
	{
		target: '[data-testid="pre-compliance-add-input"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add a compliance question</h3>
				<p>
					Type a question suppliers will be checked against, then press Enter or
					click <strong>Add question</strong>.
				</p>
				<p className="mt-2 text-gray-500">
					For example:{" "}
					<em>&ldquo;Do you hold current public liability insurance?&rdquo;</em>
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="pre-compliance-add-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add it to the list</h3>
				<p>
					Click <strong>Add question</strong> to append it. Add as many
					questions as you need — each supplier will be assessed against all of
					them.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="pre-compliance-questions-list"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Review &amp; refine</h3>
				<p>
					Edit the wording inline, remove questions you don&apos;t need, and drag
					to reorder. Questions can be loaded from your company defaults and
					tailored per RFx.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="pre-compliance-proceed-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Proceed to the grid</h3>
				<p>
					Once at least one question is added, click{" "}
					<strong>Proceed to Compliance Check</strong> to assess each supplier
					against your questions.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="pre-compliance-skip-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Or skip the check</h3>
				<p>
					Don&apos;t need a compliance check? <strong>Skip Compliance Check</strong>{" "}
					marks every submission as compliant and includes them all in the
					evaluation. You can start a compliance check later.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
